<template>
	<div class="m-title flex-between-center" :style="{'margin': unitData.margin == 1 ? '0 24px' : '0 12px'}">
		<p :style="{'font-size': `${(unitData.title_size || 36) / 2}px`, 'color': unitData.color == '2' ? '#fff' : '#000'}">{{unitData.title_text || '未填写标题文字'}}</p>
		<span v-if="unitData.more_link" class="more" :style="{'color': unitData.color == '2' ? 'rgba(255,255,255,0.6)' : '#999'}">{{unitData.more_text || '查看更多'}}</span>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-title {
		height: 40px;
		margin: 0 24px;
		
		p {
			font-size: 18px;
			font-weight: bold;
		}
			
		.more {
			font-size: 12px;
			color: #999;
		}
	}
</style>
